import { CrudService } from './CrudService';
import { resources } from '../resources';
import { QuestionnaireVersionDto } from '../models/questionnaire/QuestionnaireVersionDto';
import { QuestionDto } from '../models/questionnaire/QuestionDto';
import { QuestionnaireVersionQueryParams } from '../params/QuestionnaireVersionQueryParams';
import { Args } from './BaseService';
import { AxiosPromise } from 'axios';
import { ReferenceDto } from '../models/employees/ReferenceDto';
import { CopyVersionRequest } from '../models/version/CopyVersionRequest';
import { CopyVersionHolderToVersionablesRequest } from '../models/version/CopyVersionHolderToVersionablesRequest';
import { CopyVersionHolderToNewVersionableRequest } from '../models/version/CopyVersionHolderToNewVersionableRequest';
import { AddLanguageVariant } from '../models/training/AddLanguageVariant';

export class QuestionnaireVersionService extends CrudService<QuestionnaireVersionDto, QuestionnaireVersionQueryParams> {
  constructor() {
    super({
      query: resources.queryQuestionnaireVersions,
      get: resources.getQuestionnaireVersion,
      create: resources.createQuestionnaireVersion,
      update: resources.updateQuestionnaireVersion,
      delete: resources.deleteQuestionnaireVersion,
      idKey: 'versionId',
    });
  }

  public getQuestions(version: string, language: string, args?: Args): AxiosPromise<QuestionDto[]> {
    return this.get<QuestionDto[]>(resources.getQuestions, { versionId: version, language, ...args });
  }

  public updateAllQuestions(version: string, language: string, payload: QuestionDto[], args?: Args): AxiosPromise<void> {
    return this.put<void>(resources.updateAllQuestions, payload, { versionId: version, language, ...args });
  }

  public addLanguageForVersion(version: string, payload: AddLanguageVariant, args?: Args): AxiosPromise<void> {
    return this.post<void>(resources.addLanguageForVersion, payload, { versionId: version, ...args });
  }

  public createCopyFromLanguageVersion(version: string, language: string, payload: AddLanguageVariant, args?: Args): AxiosPromise<void> {
    return this.post<void>(resources.createCopyFromLanguageVersion, payload, { versionId: version, language, ...args });
  }

  public deleteQVLanguageVariant(version: string, language: string, args?: Args): AxiosPromise<void> {
    return this.delete<void>(resources.deleteQVLanguageVariant, { versionId: version, language, ...args });
  }

  public copyQuestionnaireVersion(version: string, payload: CopyVersionRequest, args?: Args): AxiosPromise<ReferenceDto> {
    return this.post<ReferenceDto>(resources.copyQuestionnaireVersion, payload, { versionId: version, ...args });
  }

  public copyVersionToQuestionnaires(version: string, payload: CopyVersionHolderToVersionablesRequest, args?: Args): AxiosPromise<void> {
    return this.post<void>(resources.copyVersionToQuestionnaires, payload, { versionId: version, ...args });
  }

  public copyVersionToNewQuestionnaire(version: string, payload: CopyVersionHolderToNewVersionableRequest, args?: Args): AxiosPromise<ReferenceDto> {
    return this.post<ReferenceDto>(resources.copyVersionToNewQuestionnaire, payload, { versionId: version, ...args });
  }
}
